export default __webpack_public_path__ + "static/media/four.812e23c6.jpg";